<template>
<div class="chapter">
<div class="inner_page">
<p class="block_6">
</p>
<p class="block_7"> </p>
<p class="block_7"> </p>
<p class="block_7"> </p>
<p class="block_7"> </p>
<h1 class="block_1" id="toc_id_4">Acknowledgement</h1>
<p class="block_7"> </p>
<p class="block_7"> </p>
<p class="block_7"> </p>
<p class="block_4">I would like to thank Austin Macauley Publishers for believing in the story and all the assistance getting the work to you, the readers of the world.</p>
<p class="block_8" id="calibre_pb_3"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_003.vue?f35905e6